import { createContext } from "react";

export const ContextState = createContext();
